// Specialty classification helpers for conditional UI rendering

export const REHAB_SPECIALTIES = [
  'physical_therapy',
  'occupational_therapy',
  'speech_language_pathology',
];

/**
 * Returns true if the given clinical specialty is a rehab specialty.
 * Rehab providers see a minimal encounter creation form (case + template only).
 * @param {string} [specialty]
 * @returns {boolean}
 */
export function isRehabSpecialty(specialty) {
  return REHAB_SPECIALTIES.includes(specialty);
}
